// Action Types
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const PERFIL = "PERFIL";

// Actions
export const loginAction = (value) => ({
	type: LOGIN,
	value: value,
});

export const logoutAction = (value) => ({
	type: LOGOUT,
	value: value,
});

// Reducer
const initialState = {
	login: {
		token: localStorage.getItem("token"),
		refresh_token: localStorage.getItem("refresh_token"),
		// permissao_cadastrar: JSON.parse(localStorage.getItem("permissao_cadastrar")),
		usuario_admin: JSON.parse(localStorage.getItem("usuario_admin")),
		// usuario_gestor: JSON.parse(localStorage.getItem("usuario_gestor")),
		org: localStorage.getItem("org"),
		isAuthenticated: JSON.parse(localStorage.getItem("isAuthenticated")),
	},
};

export const loginReducer = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				login: action.value,
			};
		case LOGOUT:
			localStorage.removeItem("access");
			localStorage.removeItem("refresh");
			return {
				...state,
				token: null,
				refresh_token: null,
				isAuthenticated: false,
			};

		default:
			return state;
	}
};

export const selectToken = (state) => state.login.login.token;
export const selectRefreshToken = (state) => state.login.login.refresh_token;
export const selectPermissaoCadastrar = (state) => state.login.login.permissao_cadastrar;
export const selectIsAuthenticated = (state) =>
	state.login.login.isAuthenticated;
export const selectIsAdmin = (state) => state.login.login.usuario_admin;
export const selectIsGestor = (state) => state.login.login.usuario_gestor;
export const selectOrg = (state) => state.login.login.org;

export default loginReducer;
